// src/components/auth/pages/ResetPassword.tsx

import { Link, useLocation } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import ResetPasswordForm from "@/components/auth/components/ResetPasswordForm";
import useResetPassword from "./useResetPassword";
import { LOGO } from "@/components/auth/assets";

export default function ResetPassword() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  const { loading, success, error, handleResetPassword } =
    useResetPassword(token);

  const hasToken = !!token;

  return (
    <div className="min-h-screen bg-[#0ea5e9]/85 md:bg-[#0ea5e9] relative overflow-hidden">
      {/* soft circles */}
      <div className="pointer-events-none absolute -left-10 -top-10 h-40 w-40 rounded-full bg-white/30 blur-md" />
      <div className="pointer-events-none absolute -right-12 bottom-8 h-44 w-44 rounded-full bg-white/30 blur-md" />

      <div className="mx-auto max-w-6xl px-4 py-8 md:py-14">
        <div className="relative mx-auto max-w-md rounded-3xl bg-white shadow-[0_25px_80px_rgba(2,6,23,0.25)] overflow-hidden border border-gray-200">
          <div className="px-8 py-10">
            {/* Logo */}
            <div className="mb-4 flex items-center justify-center">
              <img src={LOGO} alt="Tranzy Tours" className="h-12" />
            </div>

            <h1 className="text-center text-3xl font-bold text-sky-600">
              Reset Password
            </h1>
            <p className="mt-1 text-center text-xs text-gray-500">
              Set a strong new password for your account.
            </p>

            {!hasToken && (
              <div className="mt-4 rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700">
                The reset link is invalid or missing. Please request a new
                password reset email.
              </div>
            )}

            {hasToken && (
              <ResetPasswordForm
                onSubmit={handleResetPassword}
                loading={loading}
                error={error}
                success={success}
              />
            )}

            <div className="mt-4 text-center text-xs">
              <Link
                to="/login"
                className="inline-flex items-center gap-1 text-gray-600 hover:text-gray-800"
              >
                <FiArrowLeft /> Back to login
              </Link>
            </div>
          </div>

          {/* bottom accent */}
          <div className="h-2 w-full bg-gradient-to-r from-sky-400 via-sky-500 to-sky-600" />
        </div>
      </div>
    </div>
  );
}
